import { render } from "./FieldBox.vue?vue&type=template&id=1f839f6f&scoped=true&ts=true"
import script from "./FieldBox.vue?vue&type=script&lang=ts"
export * from "./FieldBox.vue?vue&type=script&lang=ts"

import "./FieldBox.vue?vue&type=style&index=0&id=1f839f6f&lang=scss&scoped=true"
import "./FieldBox.vue?vue&type=style&index=1&id=1f839f6f&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f839f6f"]])

export default __exports__